import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'atw-block-footer-admin',
  templateUrl: './block-footer-admin.component.html',
  styleUrls: ['./block-footer-admin.component.scss']
})
export class AtwBlockFooterAdmin implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
